import global from './global'

const incArrs = ['新品申请记录']

const handlerResList = (arr) => {
  let rtMap = {}
  return arr.reduce((p, c) => {
    if (!c.reButton) {
      p[c.reMenu ? c.reMenu : c.reModule] = c.children
        ? incArrs.includes(c.reMenu)
          ? c.reUrl
          : handlerResList(c.children)
        : c.reUrl
      return p
    } else {
      rtMap[c.reButton] = c.reUrl ? c.reUrl : `${c.reButton}-reButton`
      return rtMap
    }
  }, {})
}

export default resList => {
  const keyVal = handlerResList(resList)
  const keyMap = {}
  const tagMap = {}
  _.mapKeys(keyVal, (v, k) => {
    if (!_.isEmpty(v)) {
      _.mapKeys(v, (v1, k1) => {
        if (_.isObject(v1)) {
          _.mapKeys(v1, (v2, k2) => keyMap[v2] = [`${k}`, `${k1}`, `${k2 || ''}`])
          _.mapKeys(v1, (v2, k2) => tagMap[v2] = `${k2 || ''}`)
        } else {
          keyMap[v1] = [`${k}`, `${k1}`]
          tagMap[v1] = `${k1}`
        }
      })
    }
  })
  global.tagMap = tagMap
  global.urlKeyMap = keyMap
}



// WEBPACK FOOTER //
// ./src/js/module/utils/urlKeyMap.js